import React, { useMemo } from 'react';
import { KitTemplateContext, KitTemplateContextProps, kitTemplateSlice } from '../context/KitTemplateContext';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { KitTemplate } from '../types/kit_template/kitTemplate';

interface KitTemplateProviderProps {
  children: React.ReactNode;
}

export default function KitTemplateProvider({ children }: KitTemplateProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.kitTemplates.items);
  const loading = useAppSelector(state => state.kitTemplates.loading);

  const kitTemplates = useMemo(() => {
    return new Map(items.map(item => [item.id, new KitTemplate(item)]));
  }, [items]);

  const kitTemplateContext: KitTemplateContextProps = {
    kitTemplates,
    kitTemplatesLoading: loading,
    setKitTemplates: (kitTemplates: Map<string, KitTemplate>) =>
      dispatch(kitTemplateSlice.actions.set([...kitTemplates.values()])),
  };

  return <KitTemplateContext.Provider value={kitTemplateContext}>{children}</KitTemplateContext.Provider>;
}
